import { render } from "./catalog.cattle.io.app.vue?vue&type=template&id=49c30de2&scoped=true"
import script from "./catalog.cattle.io.app.vue?vue&type=script&lang=js"
export * from "./catalog.cattle.io.app.vue?vue&type=script&lang=js"

import "./catalog.cattle.io.app.vue?vue&type=style&index=0&id=49c30de2&lang=scss&scoped=true"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c30de2"]])

export default __exports__